import { EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ApiService } from "../services/api.service";
import { BeforeSubmitArgs } from "./before-submit-args";
import { QQQuestionViewModel } from "./qq-question.view-model";
import { QQQuestionnaireViewModel } from "./qq-questionnaire.view-model";
import { QuestionnairePageModel } from "./questionnaire-page.model";

export class QQQuestionnairePageViewModel {
  index: number;
  id: string;
  title: string;
  questions: QQQuestionViewModel[] = [];
  visibleQuestions: QQQuestionViewModel[];
  comment: any;
  settings: any;
  visible = true;
  condition: Function;
  showHeader: boolean;
  type: string;
  step: string;
  formGroup: FormGroup;

  onNext = new EventEmitter<QQQuestionnairePageViewModel>();
  onPrev = new EventEmitter<QQQuestionnairePageViewModel>();
  onQuestionAnswered = new EventEmitter<{ question: QQQuestionViewModel, answer: string }>();

  constructor(
    public page: QuestionnairePageModel,
    public api: ApiService,
    public questionnaire: QQQuestionnaireViewModel,
    index: number
  ) {
    this.id = page.id;
    this.title = page.title;
    this.comment = page.comment;
    this.settings = page.settings;
    this.type = page.type;
    this.visible = true;
    this.index = index;
    this.type = page.type;
    this.step = page.step;
    this.showHeader = page.showHeader;
    this.questions = page.questions.map(x => new QQQuestionViewModel(x, api, this));
    this.questions.forEach(x => x.onChange.subscribe(v => this.onQuestionAnswered.emit({ question: x, answer: v })))
    this.condition = page.condition ? new Function('context', `with(context) { return ${page.condition}; }`) : null;
    this.formGroup = new FormGroup(this.questions.toDictionary(x => x.key, x => x.formControl));
  }

  checkVisibility(context: { [key: string]: string }) {
    this.questions.forEach(x => x.checkVisibility(context));
    this.visible = this.condition ? this.condition(context) : true;
  }

  async nextPage() {

    let isValid = true;
    for (const q of this.questions) {
      const args = new BeforeSubmitArgs();
      q.beforeSubmit$.emit(args);
      if (!await args.waitForResult())
        isValid = false;
    }
    if (!isValid)
      return false;

    if (this.questions.filter(x => x.error && x.visible).length)
      return false;

    let items = this.questions.filter(x => x.visible && !x.answer);
    let exists = items.length > 0;
    if (exists) {
      items.forEach(x => x.error = 'This field is required');
      return false;
    }
    this.onNext.emit(this);
    return true;
  }

  async prevPage() {
    this.onPrev.emit(this);
  }
}
